import { render, staticRenderFns } from "./CourseInfoForm.vue?vue&type=template&id=94026fee&"
import script from "./CourseInfoForm.vue?vue&type=script&lang=ts&"
export * from "./CourseInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports